import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { ReplyInTaskStore } from "../../stores/replyInTaskStore";
import { Box, Grid, TextField as MuiTextField, } from "@material-ui/core";
import { SelectField } from "@roc/ui";
import { useGeneralTasksStore } from "@roc/feature-general-tasks";
import { useLoanCommunicationStore } from "../../hooks";
import { FilterType } from "../../types/communicationTypes";
import { ForumOutlined } from "@material-ui/icons";
import { ChatSection } from "../chatSection";
import { ChatContainer } from "@chatscope/chat-ui-kit-react";
import { Autocomplete } from "@material-ui/lab";
import { Message } from "@twilio/conversations";


interface IReplyInTask {
  replyInTaskStore: ReplyInTaskStore;
  sendReplyInTaskMessage: (message: String, taskId: number, replyToMessage: Message) => void;
}

export const ReplyInTask: React.FC<IReplyInTask> = observer(({ replyInTaskStore, sendReplyInTaskMessage }) => {
  const { taskId, loanTaskOptions, selectedMessage, loanCommunicationStore, selectedTask } = replyInTaskStore;
  const { generalTasksStore } = useGeneralTasksStore();

  const [showLoading, setShowLoading] = useState<boolean>(false);

  const createChat = (taskIdParam) => {
    generalTasksStore.createTaskChatroom(taskIdParam, () => {
      loadChat()
    });
  }

  useEffect(() => {
    if (taskId && !generalTasksStore.taskRoomExist) {
      generalTasksStore.checkIfTaskRoomExist(taskId, () => loadChat(), () => createChat(taskId))
    }
  }, [taskId, replyInTaskStore.isModalOpen])

  const loadChat = () => {
    setShowLoading(true)
    loanCommunicationStore.reset();
    loanCommunicationStore.setFilter({
      type: FilterType.TASK_ID,
      value: taskId
    });
    if (loanCommunicationStore.isInternal) {
      loanCommunicationStore.getAllMessageSnippets();
    }
    loanCommunicationStore.loadMyConversations(1, 100, (totalCount, rows) => {
      setShowLoading(false);
      if (rows[0]) {
        loanCommunicationStore.setCurrentConversation(loanCommunicationStore.conversations[rows[0].conversationSid])
        if (!replyInTaskStore.readOnly) {
          replyInTaskStore.sendReplyingToMessage();
          sendReplyInTaskMessage('A response has been posted in the task room.', taskId, selectedMessage);
        }
      }
    }, () => {
      setShowLoading(false);
    });
  }

  const handleOnChange = (option) => {
    replyInTaskStore.setSelectedTask(option);
    replyInTaskStore.setTaskId(option.value);
  }

  return (
    <Grid container style={{ minHeight: '600px' }}>
      <Grid item xs={6} style={{ paddingBottom: '12px' }}>
        <Autocomplete
          id={'replyInTask-taskId'}
          value={selectedTask}
          options={loanTaskOptions}
          renderInput={(params) =>
            <MuiTextField
              variant={'outlined'}
              label={'Task'}
              {...params} />}
          getOptionLabel={(option) => option?.label ?? ''}
          getOptionSelected={(option, value) => option.label === value.label}
          onChange={(event, value) => handleOnChange(value)}
          fullWidth
          placeholder={'Please select a task'}
          noOptionsText={'No options available'}
          disabled={replyInTaskStore.readOnly}
        />
      </Grid>
      <Grid item xs={12}>
        <Grid item xs={12}>
          {generalTasksStore.taskRoomExist &&
            <Box height={'75vh'} style={{
              border: '1px solid #CBCBCB',
              borderRadius: '10px',
              padding: '8px',
            }}>
              <ChatSection
                as={ChatContainer}
                communicationStore={loanCommunicationStore}
                allowJoinConversation={true}
                allowLeaveConversation={true}
                showSnippet={false}
                showEmailAddress={false}
                allowManageParticipants={true}
                allowAddInternalParticipants={true}
                allowAddParticipants={true}
                allowRemoveParticipants={true}
                onDownloadConversation={undefined}
                onUnarchiveConversation={() => { }}
                showLoading={showLoading}
                renderReplyInTask={false}
              />
            </Box>
          }
        </Grid>
      </Grid>
    </Grid>
  );
}
);